import _actions_print from './_actions/print.js'
import _actions_preview from './_actions/preview.js'
import _actions_download from './_actions/download.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    actions:{
        download: _actions_download,
        preview: _actions_preview,
        print: _actions_print,
    },
}